import { useCallback, useState } from 'react';
import { useDeleteSupplyChainInformation } from '@/services/apis/mutations/production-declaration/use-delete-supply-chain-information';

type UseSupplyChainDeleteDialogParams = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  token?: string;
};

export function useSupplyChainDeleteDialog({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  token,
}: UseSupplyChainDeleteDialogParams) {
  const [
    supplyChainInformationIdToDelete,
    setSupplyChainInformationIdToDelete,
  ] = useState<string | null>(null);
  const { isPending, mutate: deleteSupplyChainInfo } =
    useDeleteSupplyChainInformation();

  const openDeleteDialog = useCallback((supplyChainInformationId: string) => {
    setSupplyChainInformationIdToDelete(supplyChainInformationId);
  }, []);

  const handleDeleteDialogOpenChange = useCallback(
    (nextOpen: boolean) => {
      if (isPending || nextOpen) {
        return;
      }

      setSupplyChainInformationIdToDelete(null);
    },
    [isPending],
  );

  const handleDelete = useCallback(() => {
    if (!supplyChainInformationIdToDelete) {
      return;
    }

    deleteSupplyChainInfo(
      {
        productionDeclarationId,
        materialId,
        commodityOriginId,
        supplyChainInformationId: supplyChainInformationIdToDelete,
        token,
      },
      {
        onSuccess: () => {
          setSupplyChainInformationIdToDelete(null);
        },
      },
    );
  }, [
    commodityOriginId,
    deleteSupplyChainInfo,
    materialId,
    productionDeclarationId,
    supplyChainInformationIdToDelete,
    token,
  ]);

  return {
    handleDelete,
    handleDeleteDialogOpenChange,
    isDeleteDialogOpen: supplyChainInformationIdToDelete !== null,
    isPending,
    openDeleteDialog,
  };
}
